import React, { memo, useMemo, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useStyles } from './action-items.style';
import { ActionNodeProps, useActionItems } from './action-items.hook';
import DoneIcon from '@mui/icons-material/Done';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Reject } from 'src/app/modules/Leads/components/lead-list-item/lead-operation/components/reject/reject.component';
import { Dialog } from 'src/app/common/components/Dialog/dialog/dialog.component';

export const ActionItems: React.FC<ActionNodeProps> = memo((props: ActionNodeProps) => {
  const { classes } = useStyles();
  const styles = useMemo(() => classes, [classes]);

  const { accept, t, toReject, reject, setToReject } = useActionItems(props);
  const [showImportNotice, setShowImportNotice] = useState(false);

  return (
    <Box paddingRight={'16px'}>
      <Button
        onClick={() => setToReject(true)}
        variant="text"
        className={styles.enable}
        startIcon={<RemoveCircleOutlineIcon />}
      >
        <Typography className={styles.iconButtonText}>{t('app.button.remove')}</Typography>
      </Button>
      <Button
        onClick={() => setShowImportNotice(true)}
        variant="text"
        className={styles.enable}
        startIcon={<DoneIcon />}
      >
        <Typography className={styles.iconButtonText}>{t('campaign.lead.accept.selected')}</Typography>
      </Button>
      <Dialog
        title={t('important_notice')}
        content={t('accept_tips')}
        confirmBtnText={t('global.text.yes')}
        cancelBtnText={t('global.text.no')}
        open={showImportNotice}
        onConfirm={() => {
          setShowImportNotice(true);
          accept();
        }}
        onClose={() => {
          setShowImportNotice(false);
        }}
      />
      {toReject ? <Reject onClose={() => setToReject(false)} onReject={reject} /> : null}
    </Box>
  );
});
